import { MutationTree } from 'vuex'
import { ConfigurationPanelState } from '@/store/modules/configurationPanel/configurationPanelTypes'

export const mutations: MutationTree<ConfigurationPanelState> = {

}
